module.exports = __webpack_public_path__ + "img/u1.3b8d0742.png";